
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

const UserSection = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (!user) return null;

  return (
    <div className="flex flex-col gap-4">
      {!isMobile && (
        <div className="flex items-center gap-3">
          <Avatar>
            <AvatarFallback className="bg-primary text-white">
              {user.name.split(" ").map(n => n[0]).join("")}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col">
            <span className="font-medium">{user.name}</span>
            <span className="text-xs text-muted-foreground capitalize">{user.role}</span>
          </div>
        </div>
      )}
      {!isMobile && <Separator />}
      <Button 
        variant="outline" 
        className={`w-full justify-${isMobile ? "center" : "start"}`}
        onClick={handleLogout}
      >
        <LogOut className={`w-4 h-4 ${isMobile ? "" : "mr-2"}`} />
        {isMobile ? null : "Uitloggen"}
      </Button>
    </div>
  );
};

export default UserSection;
